/**
 * Helper that returns all special attributes from the given node, specifically
 * all data-* and aria-* attributes, which should always be propagated "as is"
 * to the React-nodes.
 */
export function getAriaAndDataAttributes(node: Node): { [key: string]: string | boolean } {
    const attributes = Array.from((<Element>node).attributes);
    const props: { [key: string]: string | boolean } = {};

    // Identify all "data-*" and "aria-*" attributes and propagate them to the
    // created react-element
    for (const attr of attributes) {
        // Skip empty values
        if (attr.nodeValue === null) {
            continue;
        }

        // Allow all data-* and aria-* attributes
        if (
            attr.nodeName.indexOf("data-") === 0 ||
            attr.nodeName.indexOf("aria-") === 0
        ) {
            props[attr.nodeName] = attr.nodeValue;
        }
    }

    return props;
}
